import React from "react";
import RangeSlider from "./RangeSlider";

function pctDisplay(v) {
  return v === 0 ? "Any" : `${v}%+`;
}

export default function GcseResultsFilterPanel({ filters, updateFilter }) {
  return (
    <div className="v2-filter-panel">
      <RangeSlider
        label="Grades 8-9 %"
        value={filters.gcseGrade89}
        onChange={(v) => updateFilter("gcseGrade89", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.gcseGrade89)}
      />
      <RangeSlider
        label="Grades 7-9 %"
        value={filters.gcseGrade79}
        onChange={(v) => updateFilter("gcseGrade79", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.gcseGrade79)}
      />
      <RangeSlider
        label="Attainment 8"
        value={filters.attainment8}
        onChange={(v) => updateFilter("attainment8", v)}
        min={0}
        max={90}
        step={5}
        displayValue={filters.attainment8 === 0 ? "Any" : `${filters.attainment8}+`}
      />
      <RangeSlider
        label="Progress 8"
        value={filters.progress8}
        onChange={(v) => updateFilter("progress8", v)}
        min={-1}
        max={2}
        step={0.1}
        displayValue={filters.progress8 === -1 ? "Any" : filters.progress8 >= 0 ? `+${filters.progress8.toFixed(1)}` : filters.progress8.toFixed(1)}
      />
      <RangeSlider
        label="English & Maths 5+"
        value={filters.engMath5}
        onChange={(v) => updateFilter("engMath5", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.engMath5)}
      />
      <RangeSlider
        label="EBacc Entry %"
        value={filters.ebaccEntry}
        onChange={(v) => updateFilter("ebaccEntry", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.ebaccEntry)}
      />
    </div>
  );
}
